/** User prefs + last notified fingerprint for Elite Pulse report push alerts. */

export const ELITE_PULSE_NOTIFY_SETTINGS_KEY = 'mmec-elite-pulse-notify-settings';
export const ELITE_PULSE_NOTIFY_CHANGED = 'mmec-elite-pulse-notify-changed';

export interface ElitePulseNotifySettings {
  /** Master switch for in-app popup + browser push when a new report is detected. */
  enabled: boolean;
  /** Request/show OS-level Notification API alerts (requires permission). */
  browserPushEnabled: boolean;
}

// Quiet by default: no in-app report popup, no OS permission prompt, no push,
// until the user turns it on in the Elite Pulse notification settings.
export const DEFAULT_ELITE_PULSE_NOTIFY_SETTINGS: ElitePulseNotifySettings = {
  enabled: false,
  browserPushEnabled: false,
};

export function loadElitePulseNotifySettings(): ElitePulseNotifySettings {
  try {
    const raw = localStorage.getItem(ELITE_PULSE_NOTIFY_SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_ELITE_PULSE_NOTIFY_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<ElitePulseNotifySettings>;
    // Off unless the stored value is explicitly true (opt-in, not opt-out).
    return {
      enabled: parsed.enabled === true,
      browserPushEnabled: parsed.browserPushEnabled === true,
    };
  } catch {
    return { ...DEFAULT_ELITE_PULSE_NOTIFY_SETTINGS };
  }
}

export function saveElitePulseNotifySettings(settings: ElitePulseNotifySettings): void {
  try {
    localStorage.setItem(ELITE_PULSE_NOTIFY_SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(ELITE_PULSE_NOTIFY_CHANGED, { detail: settings }));
}

const LAST_FP_KEY = 'mmec-elite-pulse-last-notified-fp';

export function loadLastNotifiedFingerprint(): string {
  try {
    return localStorage.getItem(LAST_FP_KEY) || '';
  } catch {
    return '';
  }
}

export function saveLastNotifiedFingerprint(fp: string): void {
  try {
    localStorage.setItem(LAST_FP_KEY, fp);
  } catch {
    /* ignore */
  }
}
